import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CoreService } from '../core/core.service';
import { AdService } from './ad.service';
import { Main } from '../core/main.service';
import { environment } from '@env/environment';

@Component({
  selector: 'cp-ads',
  templateUrl: './ads.component.html',
})

export class AdsComponent {

  ad: any = {};
  options: any;
  file: any;
  isLoading: any;
  id: string;
  adForm!: FormGroup;
  config: any;
  operation: string;
  selectedSale: any;
  clients: any = [];

  filter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  sales: any[];
  ads: any[];
  awards: any[];
  ekubMembers: any[];
  baseUrl: string = environment.production
    ? environment.ONLINE_BASE_URL :
    environment.LOCAL_BASE_URL;

  files: File[] = [];
  files_temp: any[];
  localUrl: any;
  uploadResponse = { status: '', message: '', filePath: '' };
  uploading = false;
  successUploadCount = 0;
  failedUploadCount = 0;

  constructor(private route: ActivatedRoute,
    private formBuilder: FormBuilder, private mainService: Main, private api: AdService, private router: Router,
    @Inject(Restangular) public Restangular) {
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.filter = '';
    this.isLoading = false;
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
    }
    this.operation = 'add';
  }

  get client() { return this.adForm.get('client'); }
  get title() { return this.adForm.get('title'); }
  get subtitle() { return this.adForm.get('subtitle'); }
  get status() { return this.adForm.get('status'); }
  get remark() { return this.adForm.get('remark'); }

  ngOnInit() {
    this.createForm();
    this.getAds();
    this.getClients();
  }

  getClients() {
    this.api.getAllClients('?all=true').subscribe((resp: any) => {
      debugger;
      this.clients = resp.data;
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      debugger;
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });
    });
  }

  getclientAds(ekubId: any) {
    debugger;
    this.api.getClientAds(ekubId).subscribe((res: any) => {
      debugger;
      if (res.data) {
        this.ekubMembers = res.data;
        if (this.selectedSale) {
          var index = this.ekubMembers.map(x => {
            return x.id;
          }).indexOf(this.selectedSale.award.data.winner.data.id);
          this.ekubMembers.splice(index, 1);
        }
        for (let member of this.ekubMembers) {
          member.text = member.username;
          member.id = member.id;
        }
      }
    });
  }

  getAds() {
    debugger;
    this.api.getAds(this.currentPage, this.filter).subscribe((resp: any) => {
      debugger;
      this.ads = resp.data;
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      debugger;
      //this.coreService.addToast('Error', err.statusText);
    });
  }

  private createForm() {

    this.adForm = this.formBuilder.group({
      client: ['', [Validators.required,]],
      title: ['', [Validators.required]],
      subtitle: ['', [Validators.required]],
      status: ['pending', [Validators.required]],
      remark: [''],
    });
  }

  getAd() {
    this.api.getAd(this.id).subscribe((res: any) => {
      debugger;
      this.ad = res.data;
      this.adForm.setValue(res.data);
    });
  }


  changeStatus(id: any, status: any) {
    this.api.changeAdStatus(id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getAds();
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

    });
  }

  addAd(id:string) {
    debugger;
    this.isLoading = !this.isLoading;
    this.ad = this.adForm.value;
    this.api.createAd(this.ad, id).subscribe((res: any) => {
      debugger;
      this.isLoading = !this.isLoading;
      this.adForm.reset();
      this.getAds();
      if (this.files_temp.length > 0) {
        this.uploadFile(res.data.id);
      }
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Ad successfully updated! ' : 'Ad  successfully added!', type: 'dark' });
    }, (err) => {
      debugger;
      err = err;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Error', body: (err.data.detail) ? err.data.detail : (this.id) ? 'Could not update ad!' : 'Could not add ad!', type: 'danger' });
    });
  }

  reset() {
    debugger;
    this.operation = 'add';
    this.adForm.reset();
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getAds();
  }

  editAd(ad: any) {
    debugger;
    this.ad = ad;
    this.adForm.get('title').setValue(ad.title);
    this.adForm.get('subtitle').setValue(ad.subtitle);
    this.adForm.get('client').setValue(ad.client.data.id);
    this.adForm.get('status').setValue(ad.status);
    this.adForm.get('remark').setValue(ad.remark);
    this.operation = 'update';
  }


  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  onFilesAdded(files: any) {
    let j = 0;
    this.files = files.addedFiles;
    for (let file of this.files) {
      if (j > 4) {
        break;
      }
      let fileName: any;
      fileName = file['name'];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.localUrl = event.target.result;
          this.compress(this.localUrl, fileName);
        }
        reader.readAsDataURL(file);
      }
      j++;
    }
  }


  async compress(image: any, fileName: string) {
    console.log('compressing...');
    this.files_temp = await this.mainService.compressFile(image, fileName);
    debugger;
    console.log(this.files_temp);

  }

  public async uploadFile(id: any) {
    debugger;
    this.successUploadCount = 0;
    this.failedUploadCount = 0;
    /* for (let file of this.files) { */
    for (let file of this.files_temp) {
      console.log(file);
      const formData = new FormData();
      if (file instanceof File) {
        formData.append('file', file, file.name);
        formData.append('item_id', id);
        formData.append('designation', 'logo');
        this.uploading = true;
        await this.mainService.upload(formData).then((res: any) => {
          this.uploadResponse = res;
          console.log(res);
          if (this.uploadResponse.status !== 'progress' &&
            this.uploadResponse.status !== 'unhandeled event') {
            this.successUploadCount++;
            let temp = (this.successUploadCount / this.files.length) * 100;
            this.uploadResponse.message = temp.toString();
          }
        }, function (err) {
          debugger;
          this.failedUploadCount++;
        });
        if (this.successUploadCount > 0) {
          this.mainService.toast({ title: 'Success', body: 'Ad Banner successfully uploaded! ', type: 'dark' });
        }

      }
    }
  }

  setAd(ad: any) {
    debugger;
    this.ad = ad;
  }

}
